<div class="main-content">
  <div *ngIf="isLoading" class="overlay">
    <div class="spinner"></div>
  </div>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div
        class="col-4 col-md-2"
        *ngFor="let card of resumenCardsTwo; index as i"
      >
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 1 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
                >
                  <!-- {{ card.value }} -->
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-6 justify-content-center">
      <div class="col-md-6 text-center">
        <a
          class="btn btn-dark btn-sm btn-initial"
          [routerLink]="['/billing/invoices/contacts']"
        >
          Customers
        </a>
        <!-- <a
          class="btn btn-dark btn-sm btn-initial"
          [routerLink]="['/billing/invoices/items']"
        >
          Items
        </a> -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} invoice</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="customer_id"
                      >Client</label
                    >
                    <select
                      class="form-control"
                      id="customer_id"
                      formControlName="customer_id"
                      (change)="onClientChange($event)"
                    >
                      <option value="">Select a client</option>
                      <option
                        *ngFor="let item of contacts"
                        [value]="item.contact_id"
                      >
                        {{ item.contact_name }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('customer_id')"
                    >
                      The client is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="company"
                      >Company</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="company"
                      formControlName="company"
                      readonly
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('company')"
                    >
                      The company is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="email">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      formControlName="email"
                      readonly
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('email')"
                    >
                      The email is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      readonly
                    />
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <label class="bmd-label-floating" for="item">Item</label>
                </div>
              </div> -->

              <div class="row">
                <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="description"
                      >Description</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="description"
                      formControlName="description"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('description')"
                    >
                      The description is required
                    </div>
                  </div>
                </div> -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="item_name"
                      >Description</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="item_name"
                      formControlName="item_name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('item_name')"
                    >
                      The description is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="item_name"
                      >Item name</label
                    >
                    
                   <select
                      class="form-control"
                      id="item_id"
                      formControlName="item_id"
                      (change)="onItemChange($event)"
                    >
                      <option value="">Select a item</option>
                      <option *ngFor="let item of items" [value]="item.item_id">
                        {{ item.item_name }}
                      </option>
                    </select> 
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('item_name')"
                    >
                      The item name is required
                    </div>
                  </div>
                 </div> -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="rate">Amount</label>
                    <input
                      type="number"
                      class="form-control"
                      id="rate"
                      formControlName="rate"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('rate')"
                    >
                      The rate is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="quantity"
                      >Quantity</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="quantity"
                      formControlName="quantity"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('quantity')"
                    >
                      The quantity is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark btn-sm pull-right btn-initial"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>

              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
